<template>
  <div class="md:text-left text-right">
    <div class="relative inline-block text-left">
      <div class="mr-auto">
        <p
          class="
            flex
            rounded-md
            border border-gray-300
            shadow-sm
            px-4
            py-2
            bg-white
            text-md
            font-medium
            text-gray-700
            hover:bg-gray-50
            focus:outline-none
            cursor-pointer
          "
          @click="dropdown = !dropdown"
        >
          Upload new
          <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            />
          </svg>
        </p>
      </div>

      <div
        v-if="dropdown"
        class="
          origin-top-right
          absolute
          right-0
          mt-2
          w-56
          rounded-md
          shadow-xl
          focus:outline-none
          bg-white
          z-50
        "
      >
        <ul class="py-1">
          <li class="dropdown-item" @click="handleFileClick">press release</li>
          <li class="dropdown-item" @click="handleArticleClick">article</li>
          <li class="dropdown-item" @click="handleVideoClick">video</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dropdown",

  data() {
    return {
      dropdown: false,
    };
  },

  methods: {
    handleVideoClick() {
      this.$router.push({
        name: "UploadNewVideo",
      });
    },

    handleArticleClick() {
      this.$router.push({
        name: "UploadNewArticle",
      });
    },

    handleFileClick() {
      this.$router.push({
        name: "UploadNewFile",
        params: { path: "news" },
      });
    },
  },
};
</script>

<style scoped>
.dropdown-item {
  @apply text-gray-700 block px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 border border-gray-100;
}
</style>